<template>
  <base-image
    :src="src"
    :fallback-src="avatarMixinDefaultGroupAvatar"
    :alt="alt"
    :image-class="imageClass"
  ></base-image>
</template>

<script>
import BaseImage from './BaseImage.vue'
import avatarMixin from '../../../common/mixins/avatar';

export default {
  name: 'BaseAvatarImage',
  components: {BaseImage},
  mixins: [avatarMixin],
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: 'User Avatar'
    },
    imageClass: {
      type: [Object, Array, String],
      default: ''
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/image/BaseAvatarImage.vue